import dayjs from "dayjs";

//Custom Imports
import analytics from "@services/analytics";
import { getDayMonthYear } from "@utils/getFormattedDate";

const contestEvents = (type = "", payload = {}) => {
  analytics.trackEvent(type, payload);
};

export default contestEvents;

const CONTEST_TYPES = {
  SLABS: "Slab based",
  LEADERBOARD: "Leaderboard based",
  MULTIPLIER: "Multiplier based",
};

const CONTEST_SCORING_CRITERIA = {
  NMV: "NMV",
  CX_COUNT: "CX_COUNT",
  NEW_CX_COUNT: "NEW_CX_COUNT",
  QUALIFYING_CX_COUNT: "QUALIFYING_CX_COUNT",
};

const PAYOUT_TYPES = {
  CASH: "CASH",
  KIND: "KIND",
};

const PERFROMANCE_TYPES = {
  BAD: "BAD",
  GOOD: "GOOD",
  EXCELLENT: "EXCELLENT",
};

const getDayMonthContestUpdate = (date, language) => {
  const en = language === "en";
  const today = dayjs();
  const tomorrow = dayjs().add(1, "day");
  let createdAt = "";
  if (dayjs(date).isSame(today, "day")) {
    createdAt = en ? "end of the day" : "आज आ जायेगा";
  } else if (dayjs(date).isSame(tomorrow, "day")) {
    createdAt = en ? "tomorrow" : "कल तक आ जायेगा";
  } else {
    createdAt = en
      ? `on ${getDayMonthYear(date)}`
      : `${getDayMonthYear(date)} को आएगा`;
  }
  return createdAt;
};

export {
  CONTEST_TYPES,
  CONTEST_SCORING_CRITERIA,
  PAYOUT_TYPES,
  getDayMonthContestUpdate,
  PERFROMANCE_TYPES,
};
